<template>
	<Layout>
		<div class="rwt-gallery-area rn-section-gap">
		    <div class="container">
		        <div class="row">
		            <div class="col-lg-12 mb--20">
		                <SectionTitle
		                    text-align="center"
		                    subtitle=""
		                    title="省级研发中心"
		                />
		            </div>
		        </div>
		        <Gallery :gallery-data="galleryData"/>
		    </div>
		</div>
		
		<div class="rwt-gallery-area rn-section-gapBottom">
		    <div class="container">
		        <div class="row">
		            <div class="col-lg-12 mb--20">
		                <SectionTitle
		                    text-align="center"
		                    subtitle=""
		                    title="发明专利"
		                />
		            </div>
		        </div>
		        <Gallery :gallery-data="galleryData1" column="col-lg-4 col-md-6 col-sm-6 col-12 mt--30"/>
		    </div>
		</div>
		
		
		<div class="rwt-gallery-area rn-section-gapBottom">
		    <div class="container">
		        <div class="row">
		            <div class="col-lg-12 mb--20">
		                <SectionTitle
		                    text-align="center"
		                    subtitle=""
		                    title="获奖证书"
		                />
		            </div>
		        </div>
		        <Gallery :gallery-data="galleryData2_1" column="col-lg-3 col-md-6 col-sm-6 col-12 mt--30"/>
				<br/>
				<Gallery :gallery-data="galleryData2_2" column="col-lg-3 col-md-6 col-sm-6 col-12 mt--30"/>
		    </div>
		</div>
		
		<div class="rwt-gallery-area rn-section-gapBottom">
		    <div class="container">
		        <div class="row">
		            <div class="col-lg-12 mb--20">
		                <SectionTitle
		                    text-align="center"
		                    subtitle=""
		                    title="软件开发"
		                />
		            </div>
		        </div>
		        <Gallery :gallery-data="galleryData3_1" column="col-lg-3 col-md-6 col-sm-6 col-12 mt--30"/>
				<br/>
				<Gallery :gallery-data="galleryData3_2" column="col-lg-3 col-md-6 col-sm-6 col-12 mt--30"/>
		    </div>
		</div>
	</Layout>
</template>

<script>
	import Layout from '../components/common/Layout'
	import SectionTitle from "../components/elements/sectionTitle/SectionTitle";
	import Gallery from "../components/elements/gallery/Gallery";
	import Video from '../components/elements/video/Video'
	
	export default {
		name:'QualificationyAwardsPage',
		components:{
			Layout,SectionTitle,Gallery,Video
		},
		data(){
			return{
				videoData: [
                    {
                        thumb: require(`@/assets/images/edge/home/homeBuilding.jpg`),
                        src: require('@/assets/video/01_高清1080P.mp4'),
                    }
                ],
				galleryData: [					    
						{
						    id: 9,
						    thumb: require(`@/assets/images/edge/QualificationyAwards/Qualification_9.jpg`),
						    src: require(`@/assets/images/edge/QualificationyAwards/Qualification_9.jpg`),
						    type: 'image'
						},
						{
						    id: 4,
						    thumb: require(`@/assets/images/edge/QualificationyAwards/Qualification_4.jpg`),
						    src: require(`@/assets/images/edge/QualificationyAwards/Qualification_4.jpg`),
						    type: 'image',
						},
						{
						    id: 6,
						    thumb: require(`@/assets/images/edge/QualificationyAwards/Qualification_6.jpg`),
						    src: require(`@/assets/images/edge/QualificationyAwards/Qualification_6.jpg`),
						    type: 'image',
						},
						{
						    id: 8,
						    thumb: require(`@/assets/images/edge/QualificationyAwards/Qualification_8.jpg`),
						    src: require(`@/assets/images/edge/QualificationyAwards/Qualification_8.jpg`),
						    type: 'image'
						},
						{
						    id: 3,
						    thumb: require(`@/assets/images/edge/QualificationyAwards/Qualification_3.jpg`),
						    src: require(`@/assets/images/edge/QualificationyAwards/Qualification_3.jpg`),
						    type: 'image',
						},
						{
						    id: 5,
						    thumb: require(`@/assets/images/edge/QualificationyAwards/Qualification_5.jpg`),
						    src: require(`@/assets/images/edge/QualificationyAwards/Qualification_5.jpg`),
						    type: 'image',
						},
						{
					        id: 1,
					        thumb: require(`@/assets/images/edge/QualificationyAwards/Qualification_1.jpg`),
					        src: require(`@/assets/images/edge/QualificationyAwards/Qualification_1.jpg`),
					        type: 'image',
					    },
						{
						    id: 2,
						    thumb: require(`@/assets/images/edge/QualificationyAwards/Qualification_2.jpg`),
						    src: require(`@/assets/images/edge/QualificationyAwards/Qualification_2.jpg`),
						    type: 'image',
						}
				],
				galleryData1:[
					{
					    id: 1,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/Patent_1.jpg`),
					    src: require(`@/assets/images/edge/QualificationyAwards/Patent_1.png`),
					    type: 'image',
						Label: '高速总线主从网络通信调度方法'
					},
					{
					    id: 2,
						thumb: require(`@/assets/images/edge/QualificationyAwards/Patent_2.jpg`),
						src: require(`@/assets/images/edge/QualificationyAwards/Patent_2.png`),
						type: 'image',
						Label: '输出优先实现最短报文的HEBus高效现场总线系统及通信方法'
					},				
					{
					    id: 3,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/Patent_3.jpg`),
					    src: require(`@/assets/images/edge/QualificationyAwards/Patent_3.png`),
					    type: 'image',
						Label: '基于温度场拟合实现热电偶冷端温度补偿的方法'
					},
					{
					    id: 4,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/Patent_4.jpg`),
					    src: require(`@/assets/images/edge/QualificationyAwards/Patent_4.png`),
					    type: 'image',
						Label: '一种串口线变换电路'
					},
					{
					    id: 5,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/Patent_5.jpg`),
					    src: require(`@/assets/images/edge/QualificationyAwards/Patent_5.png`),
					    type: 'image',
						Label: '一种基于双核处理器的PAC实时控制系统'
					},
					{
					    id: 6,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/Patent_6.jpg`),
					    src: require(`@/assets/images/edge/QualificationyAwards/Patent_6.png`),
					    type: 'image',
						Label: '一种配有视觉的搞死并联机器人拾取装置'
					},					
					{
					    id: 7,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/Patent_8.jpg`),
					    src: require(`@/assets/images/edge/QualificationyAwards/Patent_8.png`),
					    type: 'image',
						Label: '一种压力传感器及其平面复合差动方法'
					},
					{
					    id: 8,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/Patent_9.jpg`),
					    src: require(`@/assets/images/edge/QualificationyAwards/Patent_9.png`),
					    type: 'image',
						Label: '一种用户运动控制系统的圆心模式控件圆弧插补方法'
					},
					{
					    id: 9,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/Patent_7.jpg`),
					    src: require(`@/assets/images/edge/QualificationyAwards/Patent_7.jpg`),
					    type: 'image',
						Label: '一种支持ModBus和PPI协议复用的实时串行通信系统'
					},
				],
				galleryData2_1:[
					{
					    id: 15,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/NationalTechnicalInventionAward.jpg`),
					    src: require(`@/assets/images/edge/QualificationyAwards/NationalTechnicalInventionAward.jpg`),
					    type: 'image',
						Label:'国家技术发明二等奖'
					},
					{
					    id: 12,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/Certificate_2.jpg`),
					    src: require(`@/assets/images/edge/QualificationyAwards/Certificate_2.jpg`),
					    type: 'image',
						Label:'中国国际工业博览会铜奖'
					},
					{
					    id: 13,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/Certificate_4.jpg`),
					    src: require(`@/assets/images/edge/QualificationyAwards/Certificate_4.jpg`),
					    type: 'image',
						Label:'国家火炬计划重点高新技术企业'
					},
					{
					    id: 14,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/Certificate_11.jpg`),
					    src: require(`@/assets/images/edge/QualificationyAwards/Certificate_11.jpg`),
					    type: 'image',
						Label:'中国国际高新技术成果交易会优秀产品奖'
					}					
				],
				galleryData2_2: [				    
					{
					    id: 4,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/Certificate_7.jpg`),
					    src: require(`@/assets/images/edge/QualificationyAwards/Certificate_7.jpg`),
					    type: 'image',
						Label:'中国标准创新贡献奖<br/> GB/T 20171-2006 用于工业测量与控制系统的EPA系统结构与通信规范'
					},
					{
					    id: 6,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/Certificate_12.jpg`),
					    src: require(`@/assets/images/edge/QualificationyAwards/Certificate_12.jpg`),
					    type: 'image',
						Label:'中国电子学会电子信息科学技术二等奖<br/>EPA实时工业以太网技术'
					},
					{
					    id: 8,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/Certificate_14.jpg`),
					    src: require(`@/assets/images/edge/QualificationyAwards/Certificate_14.jpg`),
					    type: 'image',
						Label:'辽宁省科技创新三等奖<br/>智能温度-数字转换微机接口板'
					},
					{
					    id: 10,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/Certificate_16.jpg`),
					    src: require(`@/assets/images/edge/QualificationyAwards/Certificate_16.jpg`),
					    type: 'image',
						Label:'辽宁省科学技术创新二等奖<br/>DUT系统数据采集模块'
					},
					{
					    id: 9,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/Certificate_15.jpg`),
					    src: require(`@/assets/images/edge/QualificationyAwards/Certificate_15.jpg`),
					    type: 'image',
						Label:'辽宁省科技进步三等奖<br/>冷水机组分布控制系统'
					},
					{
					    id: 5,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/Certificate_9.jpg`),
					    src: require(`@/assets/images/edge/QualificationyAwards/Certificate_9.jpg`),
					    type: 'image',
						Label:'辽宁省科学技术二等奖<br/>网络化可编程控制系统'
					},
					{
					    id: 7,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/Certificate_13.jpg`),
					    src: require(`@/assets/images/edge/QualificationyAwards/Certificate_13.jpg`),
					    type: 'image',
						Label:'大连市科技进步一等奖<br/>棱镜分光比色辐射温度测试系统'
					},
					{
				        id: 1,
				        thumb: require(`@/assets/images/edge/QualificationyAwards/Certificate_1.jpg`),
				        src: require(`@/assets/images/edge/QualificationyAwards/Certificate_1.jpg`),
				        type: 'image',
						Label:'实用新型专利<br/>一种双杯电容压力传感器'
				    },
					{
					    id: 2,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/Certificate_3.jpg`),
					    src: require(`@/assets/images/edge/QualificationyAwards/Certificate_3.jpg`),
					    type: 'image',
						Label:'高新技术企业证书'
					},
					{
					    id: 3,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/Certificate_6.jpg`),
					    src: require(`@/assets/images/edge/QualificationyAwards/Certificate_6.jpg`),
					    type: 'image',
						Label:'软件企业认定证书'
					}										
				],
				galleryData3_1:[
					{
					    id: 1,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_1.png`),
					    src: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_1.png`),
					    type: 'image',
						Label:'DHMI人机界面组态软件_简称DHMI'
					},
					{
					    id: 2,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_2.png`),
					    src: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_2.png`),
					    type: 'image',
						Label:'Dview组态软件'
					},
					{
					    id: 3,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_3.png`),
					    src: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_3.png`),
					    type: 'image',
						Label:'FMSDP工厂管理系统开发软件<br/>简称FMSDP'
					},
					{
					    id: 4,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_4.png`),
					    src: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_4.png`),
					    type: 'image',
						Label:'MC_Config运动控制编程软件<br/>MC_Config'
					},					
					{
					    id: 10,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_10.png`),
					    src: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_10.png`),
					    type: 'image',
						Label:'工业控制网络冗余容错系统软件<br/>简称DCCE_NRS'
					},					
					{
					    id: 12,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_12.png`),
					    src: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_12.png`),
					    type: 'image',
						Label:'基于PAC平台的IEC61131-3程序实时运行系统<br/>简称PAC实时运行系统'
					},
					{
					    id: 13,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_13.png`),
					    src: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_13.png`),
					    type: 'image',
						Label:'可编程控制器MAC300设备管理软件<br/>简称MAC300设备管理软件'
					},
					{
					    id: 14,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_14.png`),
					    src: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_14.png`),
					    type: 'image',
						Label:'实时数据交互平台软件<br/>简称DXP'
					},
					{
					    id: 15,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_15.png`),
					    src: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_15.png`),
					    type: 'image',
						Label:'无线ZigBee可编程控制系统软件<br/>简称ZigBee_PLC'
					}
				],
				galleryData3_2:[
					{
					    id: 5,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_5.png`),
					    src: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_5.png`),
					    type: 'image',
						Label:'EPA功能块组态软件V1.0<br/>简称EPA_Config'
					},
					{
					    id: 6,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_6.png`),
					    src: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_6.png`),
					    type: 'image',
						Label:'人机界面组态软件V2.1<br/>简称DUT-HMI'
					},
					{
					    id: 7,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_7.png`),
					    src: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_7.png`),
					    type: 'image',
						Label:'软PLC功能块组态软件<br/>简称PLC_Config'
					},
					{
					    id: 8,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_8.png`),
					    src: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_8.png`),
					    type: 'image',
						Label:'温度传感器分段线性软件V1.0<br/>简称DCCE_TSL'
					},
					{
					    id: 9,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_9.png`),
					    src: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_9.png`),
					    type: 'image',
						Label:'智能温度-数字转换微机接口板软件V1.0<br/>简称DCCE_ITMIB'
					},
					{
					    id: 11,
					    thumb: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_11.png`),
					    src: require(`@/assets/images/edge/QualificationyAwards/SoftwareCopyright_11.png`),
					    type: 'image',
						Label:'工业以太网可编程控制器软件<br/>简称Programmable Ethernet Controller Software'
					},
					
				]
			}/* end return{} */	
		}/* end data() */
	}
</script>

<style>
</style>